import { render } from "./footerbarTwo.vue?vue&type=template&id=6cec6276"
import script from "./footerbarTwo.vue?vue&type=script&lang=js"
export * from "./footerbarTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__